var _defs, _rect, _path, _rect2, _circle, _path2, _text, _text2, _text3, _rect3, _circle2, _circle3, _path3, _text4, _text5, _text6, _rect4, _circle4, _rect5, _path4, _text7, _text8, _text9, _rect6, _circle5, _path5, _text0, _text1, _text10, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportComplianceProblemSitePositionEvidenceModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 640,
    viewBox: "0 0 900 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Work Passport site position evidence readiness model") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wp-problem-panel",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF3FD"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "wp-problem-shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 14,
    stdDeviation: 18,
    floodColor: "#07152A",
    floodOpacity: 0.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 860,
    height: 600,
    rx: 36,
    fill: "url(#wp-problem-panel)",
    stroke: "#C9DDF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380 145C470 145 480 228 545 260M380 311C470 311 480 294 545 280M380 477C470 477 480 360 545 300",
    fill: "none",
    stroke: "#9CCCF2",
    strokeWidth: 3,
    strokeDasharray: "8 10"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 72,
    width: 320,
    height: 136,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2",
    filter: "url(#wp-problem-shadow)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 140,
    r: 30,
    fill: "#087CFF",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99 153v-27h30v27M106 133h3m5 0h3m5 0h3M106 141h3m5 0h3m5 0h3M96 153h36",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 112,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "SITE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 144,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 830
  }, "North Processing Plant")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 172,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 650
  }, "Site-specific rules")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 238,
    width: 320,
    height: 136,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2",
    filter: "url(#wp-problem-shadow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 306,
    r: 30,
    fill: "#FF2775",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 298,
    r: 7,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101 320c1-9 6-13 13-13s12 4 13 13M107 311l7 6 7-6",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 278,
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "POSITION")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 310,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 830
  }, "Maintenance Technician")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 338,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 650
  }, "Role-specific duties")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 404,
    width: 320,
    height: 136,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2",
    filter: "url(#wp-problem-shadow)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 472,
    r: 30,
    fill: "#30D6A1",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 455,
    width: 28,
    height: 34,
    rx: 3,
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107 464h14M107 471h9M107 480l4 4 9-10",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 444,
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "EMPLOYEE EVIDENCE")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 476,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 830
  }, "9 of 11 requirements current")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 504,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 650
  }, "Dates, documents and validity")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 170,
    width: 286,
    height: 300,
    rx: 28,
    fill: "#07152A",
    filter: "url(#wp-problem-shadow)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 687,
    cy: 246,
    r: 43,
    fill: "#FF6B67",
    fillOpacity: 0.14
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M687 220v39M687 278h.1",
    fill: "none",
    stroke: "#FF8E88",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 687,
    y: 325,
    textAnchor: "middle",
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.6
  }, "LIVE READINESS RESULT")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 687,
    y: 368,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 31,
    fontWeight: 860
  }, "Action required")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 687,
    y: 405,
    textAnchor: "middle",
    fill: "#B9C8DC",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 650
  }, "2 requirements must be resolved")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 602,
    y: 430,
    width: 170,
    height: 6,
    rx: 3,
    fill: "#203854"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 602,
    y: 430,
    width: 132,
    height: 6,
    rx: 3,
    fill: "#F5B642"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportComplianceProblemSitePositionEvidenceModel);
export default __webpack_public_path__ + "static/media/work-passport-compliance-problem-site-position-evidence-model.e9f0d08403faebc7f583a09c0c45b453.svg";
export { ForwardRef as ReactComponent };